// W-n in comments are the review-warning ids of the committed plan,
// docs/superpowers/plans/2026-09-19-cubbo-2818-event-close-reconciliation-wms.md.
// The rounded badge shape shared by the coverage-event state/outcome colour maps (W-12):
// the colour classes stay with their own vocabulary, only the shape lives here.
export const Pill = ({ className = '', children }) => (
  <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium ${className}`}>{children}</span>
)
